import { Modal } from '~/scripts/services/modal/modal';
import controller from './agent.controller';
import template from './agent.html';
import './agent.scss';

export class AgentModal extends Modal {
	/**
	 * @returns {Promise<*>}
	 */
	open() {
		return super.open({
			controller,
			template,
			windowTopClass: 'agent-modal',
			backdrop: true,
			// @ts-ignore
		}, {});
	}
}
